<template>
  <list ref="list" :state="1" :expired="false">
    <el-dropdown slot="column" slot-scope="{ data }">
      <el-link type="primary">{{ data.StateText }}<i class="el-icon-arrow-down" /></el-link>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-action="'/api/ProjectManage/Inquiry/SetDispatch'" :disabled="data.Director.Id != operator.Id" @click.native="onDispatch(data)">指派业务员</el-dropdown-item>
        <el-dropdown-item v-action="'/api/ProjectManage/Inquiry/SetQuote'" :disabled="data.Director.Id != operator.Id && data.Executor.Id != operator.Id" @click.native="onQuote(data)">填写报价信息</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </list>
</template>

<script>
import staffs from "@/views/company/branch/staff/_picker"
import quote from "./_quote.vue"
export default {
  components: { list: () => import("./_list.vue") },
  data () {
    return {
      operator: JSON.parse(localStorage.getItem("user"))
    }
  },
  methods: {
    //指派业务员
    onDispatch (row) {
      this.$layer.iframe({
        title: '选择人员',
        area: ['640px', '500px'],
        content: {
          content: staffs,
          parent: this,
          data: {
            callback: (res) => {
              this.$apis.project.inquiry.dispatch({
                id: row.Id,
                executor: res.User.Id
              }).then(() => {
                row.Executor = { Id: res.User.Id, Name: res.User.Name }
              }).finally(() => {
                this.loading = false
              })
            }
          }
        }
      })
    },
    //报价
    onQuote (row) {
      this.$layer.iframe({
        title: '商务报价',
        area: ['450px', 'auto'],
        content: {
          content: quote,
          parent: this,
          data: {
            row: {
              Id: row.Id,
              Price: row.BidPrice,
              Remarks: row.BidRemarks
            },
            callback: () => {
              this.$refs.list.resetForm()
            }
          }
        }
      })
    }
  }
}
</script>
